import * as React from "react";
import type { SVGProps } from "react";
const SvgWeb3SwapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="web3_swap_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm187.563 437.077a10.667 10.667 0 0 0 7.509-18.219L554.667 309.333v85.334H341.333a42.667 42.667 0 0 0 0 85.333h256a42.59 42.59 0 0 0 4.694-.256h97.536zm-373.931 74.923a10.667 10.667 0 0 0-7.253 18.432l150.954 141.568V640h213.334a42.667 42.667 0 1 0 0-85.333H325.632z"
    />
  </svg>
);
export default SvgWeb3SwapIcon;
